import React, { useState, useEffect  } from 'react';
import { Container } from "react-bootstrap";
import Multiselect from 'multiselect-react-dropdown';

function MultiSelectTest()
{

const [options, setOptions] =useState(['Option 1', 'Option 2','Test 3']);

const [country, setCountry]= useState([]);
const [gene, setGene]= useState([]);

const addOptions = (event)=>{
setOptions(event)
}
const removeOptions = (event)=>{
setOptions(event)
}

const addOptionsgene = (event)=>{
setGene(event)
}
const removeOptionsgene = (event)=>{
setGene(event)
}


useEffect(()=>{
  const getCancerType= async()=>{
    const getcountryname=[];
    const reqData= await fetch("https://www.cbioportal.org/api/cancer-types?direction=ASC&pageNumber=0&pageSize=10&projection=SUMMARY");
    const resData= await reqData.json();
    //console.log(resData);

    for(let i=0; i<resData.length; i++)
    {
      getcountryname.push(resData[i].name);
    }
    setCountry(getcountryname);
  }
getCancerType();
},[]);

useEffect(()=>{
  const getGeneType= async()=>{
    const getGENEType=[];
    const reqData= await fetch("https://www.cbioportal.org/api/genes?direction=ASC&pageNumber=0&pageSize=100&projection=SUMMARY");
    const resData= await reqData.json();
    //console.log(resData);

    for(let i=0; i<resData.length; i++)
    {
        if(!getGENEType.includes(resData[i].type))
                    getGENEType.push(resData[i].type);
    }
    setGene(getGENEType);
  }
getGeneType();
},[]);



    return(<React.Fragment>
         <Container className="content">
        <div className="row">
          <div className="col-sm-12">
         <h3 className='mt-3'>Select Multi Dropdown Checkbox in React js</h3>
         <form className="row g-3" method='post'>

             <div className="col-md-5">
                <label  className="form-label"> Select Cancer Type</label>
                    <div className="text-dark"> 
                      <Multiselect 
                      isObject={false}
                      onRemove={(event)=>{  removeOptions(options)} }
                      onSelect={ (event)=>{ addOptions(event) }}
                      options={ country }                
                      showCheckbox
                      />      
                    </div>
                </div>

                             <div className="col-md-5">
                <label  className="form-label"> Select Gene Type</label>
                    <div className="text-dark"> 
                      <Multiselect 
                      isObject={false}
                      onRemove={(event)=>{  removeOptionsgene(options)} }
                      onSelect={ (event)=>{ addOptionsgene(event) }}
                      options={ gene }                
                      showCheckbox
                      />      
                    </div>
                </div>
                

        </form>
        </div>
        </div>
        </Container>
       
    </React.Fragment>);
}

export default MultiSelectTest;